import { useEffect, useState } from 'react';
import { top10Api } from './top10Api';
export const useTop10Summary = active => {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    if (!active) return undefined;
    let current = true;
    const refresh = () => top10Api.summary().then(value => { if (current) setSummary(value); }).catch(() => { if (current) setSummary(null); });
    refresh(); window.addEventListener('top10-updated', refresh);
    return () => { current = false; window.removeEventListener('top10-updated', refresh); };
  }, [active]);
  return summary;
};